/*
 *  Accessible menu
 *  Author: Nicolas Blandel | @NicoBlandel
 *  URL: www.nicoblandel.fr
 *
 * 	Gère le focus avec la tabulation sur le menu
 */


/*
 *  MENU ACCESSIBLE ----------------------------------------------------------------------------------------------------------
 */
// Définition des variables
var mainElement, parentElement, currentElement,
	classMenu = "nav-menu",
	classHasChildren = "menu-item-has-children",
	classHover = "mhover";

// Fonction du menu Accessible
$.fn.menuAccessible = function () {
	var menu = $(this);

	// Gestion du focus au clavier : Tab & Shift+Tab
	$("."+classMenu+" [itemprop='url']").focus( function() {

		// Stocke l'element courant
		currentElement = $(this).parent();

		// Stocke le menu de 1er niveau
		mainElement = currentElement.parents('li').last();
		if ( typeof(mainElement.attr("id")) === 'undefined' ) {
			mainElement = currentElement;
		}

		// On supprime le classHover sur tous les enfants
		$("."+classMenu).find("li").removeClass(classHover);

		// N'ajoute la classHover que si l'element a des enfants
		if ( currentElement.hasClass(classHasChildren) ) {
			currentElement.addClass(classHover);
		}
		// Ajoute la classHover a tous les parents
		currentElement.parents("li").addClass(classHover);
	});

	// Gestion des fleches de direction pour sauter les sous-menus
	$(menu).keydown(function(e){
		switch (e.keyCode) {
			// Flèche droite
			case 39 :
				e.preventDefault();
				// Supprime la classHover a tous les parents
				currentElement.parents("li").removeClass(classHover);
				// Passe au menu de 1er niveau suivant
				mainElement.next().children("a").focus();
			break;

			// Flèche gauche
			case 37 :
				e.preventDefault();
				// Supprime la classHover a tous les parents
				currentElement.parents("li").removeClass(classHover);
				// Passe au menu de 1er niveau precedent
				mainElement.prev().children("a").focus();
			break;

			// Shift + Tab
			case 9 :
				if ( e.shiftKey ) {
					// Passe au menu precedent du meme niveau
					// sinon si first-child, on conserve la navigation clavier classique
					if ( !currentElement.is(":first-child") ) {
						e.preventDefault();
						currentElement.prev().children("a").focus();
					}
				}
			break;
		}
	});

	// Desactivation de tous les focus au survol de la souris
	$(menu).mouseenter(function() {
		$(":focus").blur();
		$("."+classMenu).find("li").removeClass(classHover);
	});
};

// Initialisation du menu accessible
$("."+classMenu).menuAccessible();

/*
 *  FIN MENU ACCESSIBLE ------------------------------------------------------
 */


/*
 *  RESOLUTION MOBILE ----------------------------------------------------------------------------------------------------------
 */
resizeMenu();
window.onresize = function() {
	resizeMenu();
};
/*
 *  FIN RESOLUTION MOBILE ----------------------------------------------------------------------------------------------------------
 */

$(document).ready( function(){
	if ( $('#menubloc').length ) {
		// Affiche le menu mobile
		$('#toggle-menu').click( function(e) {
			e.preventDefault();
			toggleMenu();
		});
	}
});



// Switche entre le menu mobile et le menu desktop
function resizeMenu() {
	if ( $(document).width() < 780 ) {

		if ( !$("#prim-nav").hasClass("menu-mobile") ) {

			$("#prim-nav").addClass("menu-mobile");

			// Crée l'arborescence specifique pour mobile
			$('.sub-menu').each( function(i) {
				var $parent = $(this).parent().children("a");
				if ( $parent.length ) {
					if ( !$parent.attr("href") || $parent.attr("href") != "#" ) {
						var classes = "menu-title";
						if ( $parent.parent().hasClass("current-menu-item") ) {
							classes += " current-menu-item";
						}
						if ( $parent.parent().hasClass("current-menu-parent") ) {
							classes += " current-menu-parent";
						}
						$(this).prepend( '<li class="'+classes+'"><a itemprop="url" href="'+$parent.attr("href")+'">'+$parent.html()+'</li>' );
					}
				}
				$(this).prepend( '<li class="menu-back"><a href="#back"><span>Retour</span></a></li>' );
			});

			// Gere les clicks sur le menu mobile
			// Pour eviter la duplication des evenements, on detache l'evenement s'il existe et le definit de nouveau
			$('.nav-menu a, .nav-menu .top-item').unbind("click").click( function(e) {
				var li_clicked = $(this).parent(); // li parent

				console.log($(this).html(), $(this).attr("href"))

  			$("#menubloc").animate({ scrollTop: 0 }, "fast");

				// Remonte d'1 niveau : menu retour
				if ( li_clicked.hasClass("menu-back") ) {
					e.preventDefault();
					li_clicked.closest("ul.menu-close").toggleClass("menu-close");
					li_clicked.parents(".menu-item-has-children").toggleClass("menu-open");
				}

				// Ouvre menu s'il y a sous-menu
				if ( li_clicked.hasClass("menu-item-has-children") ) {
					e.preventDefault();

					if ( li_clicked.parents(".menu-item-has-children").length ) {
						li_clicked.parents(".menu-item-has-children").toggleClass("menu-open");
					}
					// else {
					// 	// Par défaut, 1er niveau
					// 	$(".nav-menu").toggleClass("menu-open");
					// }

					if ( li_clicked.parents(".sub-menu").length ) {
						li_clicked.parents(".sub-menu").toggleClass("menu-close");
					}
					else {
						// Par défaut, 1er niveau
						$(".nav-menu").toggleClass("menu-close");
					}

					li_clicked.toggleClass("menu-open");
				}
			});
		}
	}else {
		if ( $("#prim-nav").hasClass("menu-mobile") ) {
			$("#prim-nav").removeClass("menu-mobile");

			// Crée l'arborescence specifique pour mobile
			$( '.sub-menu li' ).each( function(i) {
				$(".menu-back").remove();
				$(".menu-title").remove();
			});
		}

		// Affichage du megamenu
		$(".main-menu a").mouseenter(function(e) {
			$("#prim-nav").addClass("show")
			$("body").addClass("menu-active")
			$("#prim-nav .menu-item.active").removeClass("active")
			$("#prim-nav").find("#"+$(this).parent().data('menu')).addClass("active")
		})

		$("#prim-nav").mouseenter(function(e) {
			$(this).addClass("show")
			$("body").addClass("menu-active")
		})

		$("#prim-nav, .main-menu").mouseleave(function() {
			$("#prim-nav").removeClass("show")
			$("body").removeClass("menu-active")
			$("#prim-nav .nav-menu > .menu-item.active").removeClass("active")
		})

		$("#prim-nav .nav-menu > .menu-item").mouseenter(function(e) {
			$("#prim-nav .nav-menu > .menu-item.active").removeClass("active")
			$(this).addClass("active")
		})
	}
}

// Gère l'ouverture/fermeture du menu et des élements associés
function toggleMenu( action ) {
	$('body').toggleClass("menu-active");
}
